import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DeviceService, DevicesService } from '@rocksoft/osupdates-sdk';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import * as DevicesRouterStoreSelectors from '../router/devices-router.selector';
import {
  DeviceApiActions,
  DeviceOsUpdateStatesResolverActions,
  DevicesApiActions,
  DevicesOsUpdateStatesResolverActions,
  SignalRActions,
} from './devices-os-update-status.actions';

@Injectable()
export class DevicesOsUpdateStatesEffects {
  private readonly actions = inject(Actions);
  private readonly devicesService = inject(DevicesService);
  private readonly deviceService = inject(DeviceService);
  private readonly store = inject(Store);

  osUpdateStatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DevicesOsUpdateStatesResolverActions.osUpdateStatesRequested),
      mergeMap(({ categoryId }) =>
        safeMap(
          this.devicesService.getOsUpdateStates({ categoryId }),
          (states) =>
            DevicesApiActions.osUpdateStatesLoaded({
              osUpdateStatuses: states.map((state) => ({
                categoryId: categoryId,
                udid: state.udid,
                overviewState: state.state,
              })),
            }),
          (error) => DevicesApiActions.osUpdateStatesLoadedError({ error })
        )
      )
    );
  });

  osUpdateStateRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DeviceOsUpdateStatesResolverActions.osUpdateStateRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceService.getOsUpdateState({ udid }),
          (x) => DeviceApiActions.osUpdateStateLoaded({ osUpdateStatus: x }),
          (error) => DeviceApiActions.osUpdateStateLoadedError({ error })
        )
      )
    );
  });

  osUpdateSignalRUpdateEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(SignalRActions.receivedOsUpdateStatusCommand),
      withLatestFrom(this.store.select(DevicesRouterStoreSelectors.selectUdid)),
      filter(([{ commandProgress }, currentDevice]) => commandProgress.udid === currentDevice),
      mergeMap(([{ commandProgress }]) =>
        safeMap(
          this.deviceService.getOsUpdateState({ udid: commandProgress.udid }),
          (x) => DeviceApiActions.osUpdateStateLoaded({ osUpdateStatus: x }),
          (error) => DeviceApiActions.osUpdateStateLoadedError({ error })
        )
      )
    );
  });
}
